import { render, staticRenderFns } from "./reload.vue?vue&type=template&id=5b30934c&"
import script from "./reload.vue?vue&type=script&lang=ts&"
export * from "./reload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports